export { default } from './CarPreview';
